module.exports = __webpack_public_path__ + "img/happyposonday.8e269437.png";